exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "my-solidarity{display:block}my-solidarity .container.hpd{max-width:1073px}my-solidarity .container.hpd .what-is-solidary-euro{margin-bottom:50px;display:-moz-flex;display:-ms-flexbox;display:flex;-moz-flex-direction:column;-ms-flex-direction:column;flex-direction:column;-ms-flex-align:center;-moz-align-items:center;align-items:center}my-solidarity .container.hpd .title{font-family:Stag Sans;font-size:32px;font-weight:400;color:#0072c9;text-align:center;margin-bottom:50px;margin-top:50px}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/sass-loader/dist/cjs.js!./client/app/solidarity.module/features/mySolidarity/mySolidarity.scss
// module id = 2206
// module chunks = 0